import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import NotificationPage from "../page/report.page"
import ReportPage from "../page/report.page"
export const ReportsRoute: RouteObject = {
  path: "/report",
  element: (
    <AuthGuard
      // role={["super_admin", "admin", "operator", "owner"]}
      // permission={["manage-notifications", "view-notifications"]}
    >
      <ReportPage />
    </AuthGuard>
  ),
}
